export default {
  id: 84,
  title: 'Target #84 - Junction',
  url: 'https://cssbattle.dev/play/84',
  colors: ['#191919', '#A64942', '#FE5F55'],
  solution:
    '<p a><p b><p c><p d><style>body{background:#191919}p{position:fixed;width:180;height:40;top:114;left:0;border-radius:0 20px 20px 0;transform-origin:200px 50%}[a],[c]{background:#a64942}[b],[d]{background:#fe5f55}[b]{transform:rotate(90deg)}[c]{transform:rotate(180deg)}[d]{transform:rotate(-90deg)}</style>',
}
